/** Загрузка вкладки «Голоса клиента» (#848) — одна на все вкладки и блоки. */
import { Loader2 } from 'lucide-react';

/** The section's loading state. */
export function VoiceLoading() {
  return (
    <div className="flex justify-center py-8" role="status" aria-busy="true">
      <Loader2 className="h-5 w-5 animate-spin text-fg-muted" />
    </div>
  );
}
